import USD from 'src/assets/currency/USD.png';
import ETH from 'src/assets/currency/ETH.png';
import USDT from 'src/assets/currency/USDT.png';

import {
  getActiveAddresses,
  getActiveChainId,
  contractAddresses,
  FiatCryptoBridgeAbi,
} from 'src/config/contract-loader';

// Keep these exports if older files still import them from tokenList.
export { contractAddresses, FiatCryptoBridgeAbi };

const ETH_NATIVE_ADDRESS = '0x0000000000000000000000000000000000000000';
const preloadedTokenImages = new Set();

const baseTokenList = [
  {
    type: 'crypto',
    ticker: 'USDT',
    coingeckoId: 'tether',
    img: USDT,
    name: 'Tether USD',
    decimals: 6,
  },
  {
    type: 'crypto',
    ticker: 'ETH',
    coingeckoId: 'ethereum',
    img: ETH,
    name: 'Ethereum',
    address: ETH_NATIVE_ADDRESS,
    decimals: 18,
  },
  {
    type: 'fiat',
    ticker: 'USD',
    coingeckoId: 'dollar',
    img: USD,
    name: 'US Dollar',
    address: undefined,
    decimals: 6,
  },
];

function attachAddress(token, addresses) {
  const ticker = String(token.ticker || '').toUpperCase();

  if (ticker === 'USDT') {
    if (!addresses?.usdt) {
      throw new Error('Missing USDT address for active chain');
    }

    return {
      ...token,
      address: addresses.usdt,
    };
  }

  return token;
}

export function getTokenList(chainId = getActiveChainId()) {
  const addresses = getActiveAddresses(chainId);

  return baseTokenList.map((token) => attachAddress(token, addresses));
}

export function getTokenByTicker(ticker, chainId = getActiveChainId()) {
  const wanted = String(ticker || '').toUpperCase();

  return getTokenList(chainId).find((token) => token.ticker === wanted);
}

export function getTokenMapByCoingeckoId(chainId = getActiveChainId()) {
  return Object.fromEntries(getTokenList(chainId).map((token) => [token.coingeckoId, token]));
}

export function getTokenByCoingeckoId(coingeckoId, chainId = getActiveChainId()) {
  const wanted = String(coingeckoId || '').toLowerCase();

  return getTokenList(chainId).find(
    (token) => String(token.coingeckoId || '').toLowerCase() === wanted
  );
}

// Backwards-compatible exports for existing code.
export const tokenList = getTokenList();

export const tokenByCoingeckoId = getTokenMapByCoingeckoId();

const TOKEN_IMAGE_URLS = [USD, ETH, USDT];

export function preloadTokenImages() {
  if (typeof window === 'undefined') return;

  TOKEN_IMAGE_URLS.forEach((src) => {
    if (!src || preloadedTokenImages.has(src)) return;

    const img = new Image();
    img.src = src;
    img.decoding = 'async';

    preloadedTokenImages.add(src);
  });
}

// Start loading as soon as tokenList.js is imported.
preloadTokenImages();
